// Vendors
import { cookies } from '@openbank/cf-ui-architecture-core';
// Enumerations
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Resolvers
import {
  fetchCheckoutOrderDataResolver,
  saveRedirectDataResolver,
} from '../resolvers/checkout.resolver';
// Types
import {
  CheckoutBuilderHandlersType,
  CheckoutMethodsHandlersType,
} from './types/checkout.handlers.type';
// Utilities
import { customerAuthDataHasBeenLoaded, getClientDevice } from './utils/checkout.handlers.utils';

const createTMXScript = (tmxId: string): void => {
  const script = document.createElement('script'),
    code = `window.rftmwdu.profile('${window.TMX_PROFILING_DOMAIN}', '${window.TMX_ORG_ID}', '${tmxId}')`;

  script.type = 'text/javascript';
  script.appendChild(document.createTextNode(code));
  document?.getElementsByTagName('head')?.item(0)?.appendChild(script);
};

const updateCheckoutInformationFlag =
  () =>
  (prevFlags: AppInformationNeedEnumeration[]): AppInformationNeedEnumeration[] =>
    [...prevFlags, AppInformationNeedEnumeration.CHECKOUT_DATA];

const notifyDeviceAndTmxHandler = async (tmxId: string): Promise<void> => {
  if (tmxId) {
    createTMXScript(tmxId);
    await saveRedirectDataResolver(getClientDevice());
  }
};

const fetchCheckoutOrderDataHandler = async ({
  informationFlags,
  setCheckoutOrderData,
  setInformationFlags,
  setError,
}: CheckoutBuilderHandlersType): Promise<void> => {
  if (customerAuthDataHasBeenLoaded(informationFlags)) {
    const [response] = await fetchCheckoutOrderDataResolver();

    if (response) {
      setCheckoutOrderData(response);
      setInformationFlags(updateCheckoutInformationFlag());
      const {
        customer: { phone },
        tmxId,
      } = response;
      const domain = window.location?.hostname?.includes('localhost') ? '' : '.zinia.com';
      cookies.setCookie({ name: 'username', value: phone, domain });

      notifyDeviceAndTmxHandler(tmxId);
    } else {
      setError(AppErrorEnumeration.CHECKOUT_NO_INFO);
    }
  }
};

const CheckoutHandlers = (props: CheckoutBuilderHandlersType): CheckoutMethodsHandlersType => ({
  handleFetchCheckoutOrderData: () => fetchCheckoutOrderDataHandler(props),
});

export { CheckoutHandlers };
